<div class="footer">
  <div class="main-container">
    {{"shared.copyRights" | translate}}
  </div>
</div>
